import { NotificationsCard } from "@components/Cards/NotificationsCard/NotificationsCard";

type Props = {
  initialUserTablePageIndex?: number;
};

export const Notifications = ({ initialUserTablePageIndex = 0 }: Props) => {
  return (
    <NotificationsCard
      viewMode="active"
      initialPageIndex={initialUserTablePageIndex}
    />
  );
};
